import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from "react";
import { datadogRum } from "@datadog/browser-rum";
import getConfig from "next/config";
import { isEmpty, get } from "lodash";
var DatadogProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(DatadogProvider, _React$Component);
  var _super = _createSuper(DatadogProvider);
  function DatadogProvider(props) {
    var _this;
    _classCallCheck(this, DatadogProvider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "initialiseDatadog", function () {
      var _process$env$NEXT_PUB;
      var _getConfig = getConfig(),
        publicRuntimeConfig = _getConfig.publicRuntimeConfig;
      var commitHash = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA) === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.substring(0, 7);
      datadogRum.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID || "",
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "",
        site: "datadoghq.eu",
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
        version: "".concat(publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.version, ".").concat(commitHash),
        env: window && window.location && window.location.hostname,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: true,
        //trackViewsManually: true,
        defaultPrivacyLevel: "mask-user-input"
      });
      datadogRum.startSessionReplayRecording();
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(DatadogProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (process.env.NEXT_PUBLIC_APP_ENV === "production") {
        this.initialiseDatadog();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$user = prevProps.user,
        prevUser = _prevProps$user === void 0 ? {} : _prevProps$user;
      var _this$props = this.props,
        _this$props$user = _this$props.user,
        user = _this$props$user === void 0 ? {} : _this$props$user,
        _this$props$authData = _this$props.authData,
        authData = _this$props$authData === void 0 ? {} : _this$props$authData;
      var organizations = get(authData, "authData", {});
      var sources = get(authData, "sources", []);
      var readSources = get(authData, "read_sources", []);
      var uploadSources = get(authData, "upload_sources", []);
      if (prevUser.email !== user.email && process.env.NEXT_PUBLIC_APP_ENV === "production") {
        var _navigator;
        datadogRum.setUser({
          name: user.name && user.name !== "undefined" ? user.name : user.email,
          email: user.email,
          language: (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language,
          readSources: readSources.map(function (readSource) {
            var name = get(readSource, ["name"], "");
            return name;
          }),
          uploadSources: uploadSources.map(function (uploadSource) {
            var name = get(uploadSource, ["name"], "");
            return name;
          }),
          sources: sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
            if (isEmpty(organizations[source])) {
              return source;
            }
            return organizations[source];
          })
        });
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      if (process.env.NEXT_PUBLIC_APP_ENV === "production") {
        datadogRum.addError(error, {
          scope: "error-boundary"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement(Fallback, null);
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
  return DatadogProvider;
}(React.Component);
var Fallback = function Fallback() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-full bg-black flex-col justify-center items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-white"
  }, "Application error: a client-side exception has occurred (please reload the browser)"));
};
export default DatadogProvider;